import { platformBrowser } from '@angular/platform-browser';

import { AppCrmModule } from './app/app-crm.module';

platformBrowser()
  .bootstrapModule(AppCrmModule)
  .catch((err) => console.error(err));
